// True when the current route is in the OLD-design world: `?old` in the
// query, or the path is /old. Used to keep old-world navigation (shared
// Header/Footer, self-re-routes) from snapping back to the new default.
export const isOldWorld = (r) =>
  r.query.old !== undefined || r.asPath.split('?')[0] === '/old'
